<template>
  <div>
    <div class="text-left">
      <GlobalAlert v-if="$store.state.global_alert.show" />
    </div>

    <b-modal
      size="sm"
      footer="{null}"
      id="notification_modal"
      centered
      title=""
    >
      <div class="text-center">
        <i class="mdi mdi-alert-circle-check"></i>
        <p class="">{{ $store.state.global_popup_message }}</p>
        <div>
          <button
            @click.prevent="utils_close_global_poup()"
            class="btn btn-secondary"
          >
            Fermer
          </button>
        </div>
      </div>
    </b-modal>
    <SimCardComponents />
    <SimCardDetails />
    <BundleCommon />
    <MobileMoneyRoot />
  </div>
</template>

<script>
import GlobalAlert from "@/components/utils/GlobalAlert";
import SimCardDetails from "@/components/utils/SimCardDetails";
import SimCardComponents from "@/components/sim-card/SimCardComponents";
import BundleCommon from "@/components/bundles-services/BundleCommon";
import MobileMoneyRoot from "@/components/mobile-money/MobileMoneyRoot";
export default {
  name: "Common",
  components: {
    GlobalAlert,
    SimCardDetails,
    SimCardComponents,
    BundleCommon,
    MobileMoneyRoot,
  },
};
</script>
<style scoped lang="css">
</style>
